// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rdPx","select":"styles_select__2QKd4"};